module.exports = __webpack_public_path__ + "static/media/icn-training-center.f69ffaf6.svg";